__turbopack_context__.v({
  "container": "DonationBnbController-module-scss-module__xquAdW__container",
});
